<upp-dialog *ngIf="TerminalPickOptions !== null"
    [backdropDismiss]="true"
    uppDataid="pinpad-session-pick"
    style="--upp-dialog-panel-width: 420px">
    <upp-pinpad-select
        [options]="TerminalPickOptions"
        [selected]="ChargeTerminal"
        (OnPick)="OnTerminalPick($event)"
        (OnCancel)="OnTerminalPickCancel()">
    </upp-pinpad-select>
</upp-dialog>

<upp-dialog *ngIf="PayPPadTickets !== null"
    [backdropDismiss]="false"
    uppDataid="pinpad-session-charge"
    style="--upp-dialog-panel-width: 420px">
    <upp-pinpad-payment
        [tickets]="PayPPadTickets"
        [terminal]="ChargeTerminal"
        (OnDone)="OnPinpadDone($event)">
    </upp-pinpad-payment>
</upp-dialog>

<upp-dialog *ngIf="RefundDialog !== null"
    [backdropDismiss]="false"
    uppDataid="pinpad-session-refund"
    style="--upp-dialog-panel-width: 420px">
    <upp-pinpad-payment
        operation="REFUND"
        [tickets]="[RefundDialog.ticket]"
        [terminal]="RefundDialog.terminal"
        [refund]="RefundDialog.request"
        [action]="RefundDialog.action"
        (OnDone)="OnRefundPinpadDone($event)">
    </upp-pinpad-payment>
</upp-dialog>
